import { Box, styled } from '@mui/material'

export const FullPageLoadingContainer = styled(Box)({
  backgroundColor: 'white',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})

export const SpinnerContainer = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: 'auto',
  paddingBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
}))
